var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageNode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#image_node_svg__clip0_1181_1912)",
    stroke: "#98BDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.833 3H4.167C3.247 3 2.5 3.746 2.5 4.667v11.666c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667V4.667c0-.92-.746-1.667-1.667-1.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.083 8.834a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM17.5 13l-4.167-4.166L4.167 18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "image_node_svg__clip0_1181_1912"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 9.75 10.25)",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgImageNode;